import { css } from '@/styled-system/css';

export const calendarDayOfWeekStyles = css.raw({
  textStyle: 'body-sm-bold',
  display: 'grid',
  placeItems: 'center',
  paddingBlockEnd: 'tighter',
  borderBottomStyle: 'solid',
  borderBottomColor: 'Calendar.DayOfWeek.border.default',
  borderBottomWidth: 'default',
});
